import { Component, OnInit } from '@angular/core';
import { KneServicesService } from '../shared';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-kne-services',
  templateUrl: './kne-services.component.html',
  styleUrls: ['./kne-services.component.scss'],
  providers: [KneServicesService],
})
export class KneServicesComponent implements OnInit {

  constructor(
  	private kneServicesService: KneServicesService,
     private route: ActivatedRoute,
  ) { }

  contents: any = {};
  fragment:string;

  ngOnInit() {
  	this.kneServicesService.getAllContents()
  		.subscribe(contents => {
  			this.contents = contents;
        this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  	});

  }


  ngAfterViewChecked(): void {
    try {
        if(this.fragment) {
            document.querySelector('#' + this.fragment).scrollIntoView();
        }
    } catch (e) { }
  }

  scrollTop(){
    window.scrollTo(0, 0);
  }

}


// WEBPACK FOOTER //
// ./src/app/kne-services/kne-services.component.ts